module.exports = __webpack_public_path__ + "img/google.fc0e09f4.png";